import { render, staticRenderFns } from "./docCabPatientHistory.vue?vue&type=template&id=ebd3125e&"
import script from "./docCabPatientHistory.vue?vue&type=script&lang=js&"
export * from "./docCabPatientHistory.vue?vue&type=script&lang=js&"
import style0 from "./docCabPatientHistory.vue?vue&type=style&index=0&id=ebd3125e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports